import { createI18n } from 'vue-i18n'

import {
  getAppMetadataLanguages,
  getAppMetadataLocalStorageKeys,
} from './plan/metadata/metadata'

function loadLocaleMessages(): Record<string, unknown> {
  const locales = import.meta.glob('./locales/*.json', { eager: true })
  const messages: Record<string, unknown> = {}
  Object.entries(locales).forEach(([key, value]) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = value
    }
  })
  return messages
}

function loadLocale(): string {
  return (
    window.localStorage.getItem(getAppMetadataLocalStorageKeys().lang) ||
    import.meta.env.VITE_I18N_LOCALE ||
    getAppMetadataLanguages().options[0].locale ||
    getAppMetadataLanguages().options[0].id ||
    'en'
  )
}

// Composition-API mode (no legacy VueI18n instance). Components get translations
// either via `useI18n()` in <script setup> — a bare call with no `__i18n` option
// resolves to the global scope — or via the globally-injected `$t` / `v-t` in
// templates (`globalInjection: true`). `missingWarn` is enabled so that calling
// `$t`/`t` with a key absent from the locale messages logs a warning — a useful
// signal for typos and untranslated keys during development. Call sites must
// therefore avoid translating empty/absent values (e.g. an unselected filter or
// a label-less control): resolve those to '' WITHOUT calling the translator.
export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: loadLocale(),
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  // createI18n's messages generic is too strict for dynamically-globbed JSON
  // locales; the runtime shape is unchanged from the working setup.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messages: loadLocaleMessages() as any,
  missingWarn: true,
  // Keep fallback-locale resolution quiet; only genuinely missing keys warn.
  fallbackWarn: false,
})
